import GeneralTemplateLight from './GeneralTemplateLight';

export default GeneralTemplateLight;
